export default __webpack_public_path__ + "static/media/icons-miscellaneous-circle-plus-24-px.0286ddf3.svg";